import type { UiWidget} from '@tyndo/types';

type ViewLoader = () => Promise<{ default: React.ComponentType}>;

interface WidgetEntry {
 definition: UiWidget;
 loader: ViewLoader;
 component?: React.ComponentType;
}

class WidgetRegistry {
 private widgets = new Map<string, WidgetEntry>();

 register(definition: UiWidget, loader: ViewLoader): void {
 this.widgets.set(definition.widgetId, {
 definition,
 loader,
});
}

 async resolve(widgetId: string): Promise<React.ComponentType | null> {
 const entry = this.widgets.get(widgetId);
 if (!entry) return null;

 // Load and cache the component
 if (!entry.component) {
 try {
 const loaded = await entry.loader();
 entry.component = loaded.default;
} catch (error) {
 console.error(`Failed to load widget: ${widgetId}`, error);
 return null;
}
}
 return entry.component;
}

 listWidgets(category?: string): UiWidget[] {
 const results: UiWidget[] = [];
 for (const [, entry] of this.widgets.entries()) {
 if (!category || entry.definition.category === category) {
 results.push(entry.definition);
}
}
 return results;
}

 has(widgetId: string): boolean {
 return this.widgets.has(widgetId);
}

 clear(): void {
 this.widgets.clear();
}
}

export const widgetRegistry = new WidgetRegistry();
